export const stringToBoolean = (value: string | undefined | null): boolean => {
  return value?.toLowerCase() === "true";
};
